import React from 'react';
import { formatPrice, formatDate, getStatusConfig, getSiteConfig, truncateText } from '../../../utils/productUtils';

const ProductMobileCard = ({ product, isSelected, onSelect, onClick, onDeleteProduct }) => {
  const statusConfig = getStatusConfig(product.sale_status);

  const handleCardClick = (e) => {
    // 체크박스나 삭제 버튼 클릭 시에는 상세 페이지로 이동하지 않음
    if (e.target.type === 'checkbox' || e.target.textContent === 'X') {
      return;
    }
    onClick();
  };

  return (
    <div 
      key={product.id} 
      className={`rounded-lg p-4 mb-4 shadow-md relative cursor-pointer transition-colors ${
        product.published_to_shopify 
          ? 'bg-yellow-50 hover:bg-yellow-100' 
          : 'bg-gray-50 hover:bg-gray-100'
      }`}
      onClick={handleCardClick}
    >
      <div className="absolute top-2 left-2">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => {
            e.stopPropagation();
            onSelect(product.id, e.target.checked);
          }}
          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
        />
      </div>
      <button 
        className="absolute top-2 right-2 w-[30px] text-red-500 px-1 py-1 rounded text-xs transition-colors whitespace-nowrap"
        onClick={(e) => {
          e.stopPropagation();
          if (onDeleteProduct) {
            onDeleteProduct(product.id);
          }
        }}
      >
        X
      </button>
      
      <div className="flex items-center mb-3">
        {product.media_images && product.media_images.length > 0 ? (
          <img 
            src={product.media_images[0]} 
            alt={product.title}
            className="w-12 h-12 object-cover rounded mr-3"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        ) : (
          <div className="w-12 h-12 bg-gray-200 rounded flex items-center justify-center text-xs text-gray-500 mr-3">
            이미지 없음
          </div>
        )}
        <div className="flex-1">
          <div className="font-bold text-sm mb-1 text-gray-800">
            {truncateText(product.title_en, 19)}
          </div>
          {product.title && (
            <div className="text-xs text-gray-600">
              {truncateText(product.title, 19)}
            </div>
          )}
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-2 text-xs">
        <div className="flex justify-between py-1">
          <span className="text-gray-600 font-medium">사이트:</span>
          <span className={getSiteConfig(product.source_site).className} style={getSiteConfig(product.source_site).style}>
            {getSiteConfig(product.source_site).name}
          </span>
        </div>
        <div className="flex justify-between py-1">
          <span className="text-gray-600 font-medium">브랜드:</span>
          <div className="text-right">
            {product.brand_name_en && (
              <div className="text-gray-800 text-sm">
                {truncateText(product.brand_name_en, 10)}
              </div>
            )}
            {product.brand_name && (
              <div className="text-gray-600 text-xs">
                {truncateText(product.brand_name, 10)}
              </div>
            )}
            {!product.brand_name_en && !product.brand_name && (
              <span className="text-gray-800">-</span>
            )}
          </div>
        </div>
        <div className="flex justify-between py-1">
          <span className="text-gray-600 font-medium">가격:</span>
          <div className="text-right">
            {product.price_usd && (
              <div className="text-gray-800 text-sm font-bold">
                ${product.price_usd}
              </div>
            )}
            {product.price && (
              <div className="text-gray-600 text-xs">
                {formatPrice(product.price)}
              </div>
            )}
            {!product.price_usd && !product.price && (
              <span className="text-gray-800">-</span>
            )}
          </div>
        </div>
        {/* <div className="flex justify-between py-1">
          <span className="text-gray-600 font-medium">상태:</span>
          <span className={`px-2 py-1 rounded text-xs font-medium whitespace-nowrap ${statusConfig.className}`}>
            {statusConfig.text}
          </span>
        </div> */}
        <div className="flex justify-between py-1">
          <span className="text-gray-600 font-medium">카테고리:</span>
          <span className="text-gray-800">
            {truncateText(product.category, 10)}
          </span>
        </div>
        <div className="flex justify-between py-1">
          <span className="text-gray-600 font-medium">크롤링 일시:</span>
          <span className="text-gray-800">{formatDate(product.crawled_at)}</span>
        </div>
      </div>
    </div>
  );
};

export default ProductMobileCard;
